import "./SimpleEditableCard.css";

const SimpleEditableCard = ({children, extraClasses = "", extraStyle, isEditing = false}) => (
    <div className={`editable-card ${isEditing ? "editing" : "viewing"} ${extraClasses}`} style={extraStyle}>
        {children}
    </div>
);

export default SimpleEditableCard;